"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricDataSourceEnum = void 0;
var MetricDataSourceEnum;
(function (MetricDataSourceEnum) {
    MetricDataSourceEnum["Calendar"] = "calendar";
    MetricDataSourceEnum["Conversation"] = "conversation";
    MetricDataSourceEnum["ConversationLive"] = "conversation_live";
    MetricDataSourceEnum["Notification"] = "notification";
    MetricDataSourceEnum["UserActivity"] = "user_activity";
    MetricDataSourceEnum["UserActivityTimeline"] = "user_activity_timeline";
    MetricDataSourceEnum["UserActivityHandlingTime"] = "user_activity_handling_time";
    MetricDataSourceEnum["UserActivityACW"] = "user_activity_acw";
    MetricDataSourceEnum["VoiceCall"] = "voice_call";
    MetricDataSourceEnum["MailMessage"] = "mail_message";
    MetricDataSourceEnum["FormSubmission"] = "form_submission";
    MetricDataSourceEnum["InternalNote"] = "internal_note";
})(MetricDataSourceEnum = exports.MetricDataSourceEnum || (exports.MetricDataSourceEnum = {}));
